module.exports = __webpack_public_path__ + "static/media/icon-location.6a43b1cb.svg";